import React from "react";
import { FaWhatsapp, FaInstagram } from "react-icons/fa";

const FloatingButtons = () => {
  return (
    <div className="floating-buttons">
      {/* WhatsApp */}
      <a
        href="https://wa.me/5511947109020" // coloque o número da clínica
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn whatsapp"
      >
        <FaWhatsapp size={28} />
      </a>

      {/* Instagram */}
      <a
        href="https://www.instagram.com/clinica_barbuti_atroch?igsh=Z3N5ZnJ6ZDZqaGt4" // coloque o link do Instagram da clínica
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn instagram"
      >
        <FaInstagram size={28} />
      </a>
    </div>
  );
};

export default FloatingButtons;
